import { render, staticRenderFns } from "./RejectionBusiness.vue?vue&type=template&id=3ff0b741&scoped=true&"
import script from "./RejectionBusiness.vue?vue&type=script&lang=js&"
export * from "./RejectionBusiness.vue?vue&type=script&lang=js&"
import style0 from "./RejectionBusiness.vue?vue&type=style&index=0&id=3ff0b741&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff0b741",
  null
  
)

export default component.exports